<template>
    <div class="border border-gray-400 px-4 sm:px-6 pb-6 -mt-px">
        <purchase-price
            v-model="purchase_price"
            :read_only="read_only"
        />

        <total-due
            v-model="total_due"
            :deal="property.deal"
            :purchase_price="purchase_price"
            :read_only="read_only"
        />

        <initial-amount
            v-model="initial_amount"
            :deal="property.deal"
            :read_only="read_only"
        />

        <balance-amount
            :value="balance_earnest_money"
            :attorney="property.attorney"
            :deal="property.deal"
            :read_only="read_only"
        />

        <balance-after-earnest-money
            :value="balance_after_earnest_money"
            :read_only="read_only"
        />

        <total-loan-amount
            v-model="total_loan_amount"
            :read_only="read_only"
        />

        <balance-needed-to-close
            :value="balance_needed_to_close"
            :mortgage="property.mortgage"
            :read_only="read_only"
        />
    </div>
</template>

<script>
import MoneyFunctions from '../../../mixins/money-functions.js';
import PurchasePrice from './purchase-price.vue';
import TotalDue from './total-due.vue';
import InitialAmount from './initial-amount.vue';
import BalanceAmount from './balance-amount.vue';
import BalanceAfterEarnestMoney from './balance-after-earnest-money.vue';
import TotalLoanAmount from './total-loan-amount.vue';
import BalanceNeededToClose from './balance-needed-to-close.vue';

export default {
    mixins: [
        MoneyFunctions,
    ],

    components: {
        PurchasePrice,
        TotalDue,
        InitialAmount,
        BalanceAmount,
        BalanceAfterEarnestMoney,
        TotalLoanAmount,
        BalanceNeededToClose,
    },

    props: {
        property: {},
        read_only: { default: false },
    },

    data() {
        return {
            purchase_price: this.property.purchase_price,
            total_due: this.property.deal.total_earnest_money,
            initial_amount: this.property.deal.initial_earnest_money,
            balance_amount: this.property.deal.balance_earnest_money,
            total_loan_amount: this.property.mortgage.total_loan_amount,
        }
    },

    computed: {
        balance_earnest_money() {
            return this.formatMoney(
                this.moneyVal(this.total_due) - this.moneyVal(this.initial_amount)
            );
        },
        balance_after_earnest_money() {
            return this.formatMoney(
                this.moneyVal(this.purchase_price) - this.moneyVal(this.total_due)
            );
        },
        balance_needed_to_close() {
            return this.formatMoney(
                this.moneyVal(this.balance_after_earnest_money) - this.moneyVal(this.total_loan_amount)
            );
        },
    },
}
</script>
